import { FormProvider } from "react-hook-form";
import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { nameof } from "ts-simple-nameof";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import styles from "./MyFamilyCreationDialog.module.scss";
import { ICreateFamilyFormModel, useMyFamilyCreationDialog } from "./hooks/useMyFamilyCreationDialog";

interface IMyFamilyCreationDialogProps {
  visible: boolean;
  onClose: () => void;
}

export const MyFamilyCreationDialog = ({
  visible,
  onClose,
}: IMyFamilyCreationDialogProps) => {
  const { form, width, onSubmit } = useMyFamilyCreationDialog(onClose);
  
  return (
    <AppDialog
      visible={visible}
      onHide={() => {
        form.reset();
        onClose();
      }}
      header="Създаване на семейство"
      style={{ width }}
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className={styles.dialog_contents}>
            <DefaultInputField
              name={nameof<ICreateFamilyFormModel>((x) => x.familyName)}
              label={"Име на семейството"}
              placeholder="сем. Георгиеви"
              width={"100%"}
            />

            <DefaultButton
              className={styles.dialog_contents_button}
              type="submit"
              label={"Създай"}
              width="150px"
            />
          </div>
        </form>
      </FormProvider>
    </AppDialog>
  );
};
